import { E164Number } from 'libphonenumber-js';
import { useCustomerAuthRequest } from 'hooks/useCustomerAuthApi/useCustomerAuthRequest';
import { CustomerAuthSession } from 'hooks/useCustomerAuthApi/const';

type ConfirmPhoneAuthenticationRequestState = {
  hasPending: boolean;
  request: (code: string, phone: E164Number) => Promise<CustomerAuthSession | undefined>;
  cancel: (message?: string) => void;
};

export type ConfirmPhoneAuthenticationRequestResult = ConfirmPhoneAuthenticationRequestState & [
  ConfirmPhoneAuthenticationRequestState['hasPending'],
  ConfirmPhoneAuthenticationRequestState['request'],
  ConfirmPhoneAuthenticationRequestState['cancel'],
];

export function useConfirmPhoneAuthenticationRequest(): ConfirmPhoneAuthenticationRequestResult {
  return useCustomerAuthRequest((code: string, phone: E164Number) => {
    return code && phone && ({
      method: 'PUT',
      url: '/sessions/confirmations/phone',
      data: {
        code,
        phone
      }
    });
  }, []);
}
